import { render, staticRenderFns } from "./careerList.vue?vue&type=template&id=2923f9ee&scoped=true&"
import script from "./careerList.vue?vue&type=script&lang=js&"
export * from "./careerList.vue?vue&type=script&lang=js&"
import style0 from "./careerList.vue?vue&type=style&index=0&id=2923f9ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923f9ee",
  null
  
)

export default component.exports